import decode from 'jwt-decode';
import {globales,pendientes_alumno,usuario} from './global'
import Request from 'superagent';

let global;
let render;

export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        this.domain = domain || globales.ip // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
    }

login(tokenGoo,username, password, sucursal, descrip_sucursal) { // Get a token from api server using the fetch api
    //console.log(tokenGoo)    
    return this.fetch(`${this.domain}/generar_token`, {
            method: 'POST',
            body: JSON.stringify({
                tokenGoo,
                username,
                password,
                sucursal,
                descrip_sucursal,
            })
        }).then(res => {
            //console.log(res)
            if( res.token === "Not_information" ){
                return Promise.resolve(res);
            }

            if( res.token !== "Authentication_Failed" ){
            }
            
            if(res.token!=='INTERNO')
            this.setToken(res.token) // Setting the token in localStorage

            localStorage.setItem('notificaciones', JSON.stringify(res.notificaciones))

	        pendientes_alumno.matricula=res.matricula;
            pendientes_alumno.cuotas=res.cuotas;
            pendientes_alumno.toda_factura=res.toda_factura;

            if(res.token!=='INTERNO')
            usuario.like=JSON.parse(res.LIKES);
            
            return Promise.resolve(res);
        })
    }

    get_render(){
        return render;
    }
    set_render(r){
        render=r;
    }
    /*
    ver() {
        const _this = this
        return new Promise(async function (resolve, reject) {  
            const token = _this.getToken()
             var bol;
             if(token!==null)
             Request.get(`${globales.ip}/verifica_token/`).set({'authorization': 'Bearer '+token})
             .end((err, res)=>{
                const tmp =  JSON.parse(res.text);
                if(tmp){
                    bol= true;
                }
                else{
                    bol= false;
                }
                resolve(global=bol);   
             })
            
        });
    }
    */
    loggedIn() { // Checks if there is a saved token and it's still valid
    const _this = this
    return new Promise(async function (resolve, reject) {  
        const token = _this.getToken()
        
        var bol;
         if(token!==null)
         {
            Request.get(`${globales.ip}/verifica_token/`).set({'authorization': 'Bearer '+token})
            .end((err, res) => {
		    if (err) { return resolve(false); }
                if(res!==undefined){
                    const tmp =  JSON.parse(res.text);
                    if(tmp){
                        bol= true;
                    }
                    else{
                        bol= false;
                    }
                }
                else
                bol= false;

                global=bol
                resolve(global);   
            })
         }
         else{
            global=false
            resolve(false);
         }
         /*if(token!==null)
         {
            resolve(true);
         }
         else{
            resolve(false);  
         }*/
    });
        //this.ver()
        //return global
    }
    
    setToken(idToken) { // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() { // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }

    getglobal(){
        return global;
    }

    logout() {// Clear user token and profile data from localStorage

        localStorage.removeItem('id_token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('estado_menu');
	    localStorage.removeItem('Tabs_user');
    }

     getProfile() { // Using jwt-decode npm package to decode the token
        var token=this.getToken();
        if(token!==null){
            try{
                return decode(token);
            }
            catch(error){
                return ''
            }
        }
        else
        return ''
    }

    fetch(url, options){// performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        // Setting Authorization header
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return fetch(url, {
            headers,
            ...options
        }).then(this._checkStatus).then(response => response.json())
    }

    _checkStatus(response) { // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}